import tracking from "@/businesslogic/tracking/tracking";
import { NavvItem } from "@/model/NavItem";
import { Router } from "vue-router";
import Logger from "js-logger";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default function routerUtils(): any {
  const { track } = tracking();
  const pruefeDatenVorhanden = (ziel: string, status?: string) => {
    return (to: any, from: any, next: any) => {
      const piniaStore = useFormStore();
      if (!piniaStore.state) {
        track(undefined, "router", "keineSession_UmleitungAufSchritt1_" + ziel.slice(1));
        next(ziel);
      }
      if (status && piniaStore.state.status !== status) {
        track(
          piniaStore.state.sessionId,
          "router",
          "statusNicht_" + status + "_UmleitungAufSchritt1_" + ziel.slice(1),
          piniaStore.state,
        );
        next(ziel);
      }

      next();
    };
  };

  const erzeugeNavItems = (items: NavvItem[], isMakler: boolean, isMaklerLink: boolean) => {
    const result = Array.from(items);

    for (let i = 0; i < result.length; i++) {
      if (!isMakler) {
        result[i].to = items[i].to;
      } else {
        result[i].to = (isMaklerLink ? "/makler-tarifrechner" : "/makler") + items[i].to;
      }
      if (isMakler && items[i].labelMakler !== undefined) {
        result[i].label = items[i].labelMakler;
      }
    }

    return result;
  };

  const getCurrentRouteMeta = (router: Router) => {
    return router?.currentRoute?.value?.meta;
  };

  const nextPage = (
    router: Router,
    event: any,
    items: NavvItem[],
    isMakler: boolean,
    inline: boolean,
    produkt: string,
  ) => {
    const piniaStore = useFormStore();
    const target = items[event.pageIndex + 1];
    Logger.trace(produkt, "nextPage", event, items, target);
    track(piniaStore.state.sessionId, target.trackingId, "seite_anzeigen", piniaStore.state, undefined, true);
    router.push(target.to + (inline != undefined ? "?inline=" + inline : "")).catch(() => {
      Logger.warn("Fehler beim Wechsel zur nächsten Seite", produkt, "nextPage", event, items, target);
    });

    window.parent.postMessage(
      {
        func: "schrittWechsel",
      },
      process.env.VUE_APP_MAKLERPORTAL_URL,
    );
  };

  const prevPage = (
    router: Router,
    event: any,
    items: NavvItem[],
    isMakler: boolean,
    inline: boolean,
    produkt: string,
  ) => {
    const piniaStore = useFormStore();
    Logger.trace(produkt.toUpperCase, "prevPage", event);
    const target = items[event.pageIndex - 1];
    track(piniaStore.state.sessionId, target.trackingId, "seite_anzeigen", piniaStore.state, undefined, true);
    router.push(target.to + (inline != undefined ? "?inline=" + inline : "")).catch(() => {
      Logger.warn("Fehler beim Wechsel zur vorherigen Seite", produkt.toUpperCase, "prevPage", event);
    });
  };

  const goToPage = (
    router: Router,
    event: any,
    items: NavvItem[],
    isMakler: boolean,
    inline: boolean,
    produkt: string,
  ) => {
    const piniaStore = useFormStore();
    Logger.trace(produkt.toUpperCase, "goToPage", event);
    const target = items[event.pageIndex];
    track(piniaStore.state.sessionId, target.trackingId, "seite_anzeigen", piniaStore.state, undefined, true);
    router.push(target.to + (inline != undefined ? "?inline=" + inline : "")).catch(() => {
      Logger.warn("Fehler beim Wechsel zur Seite", produkt.toUpperCase, "goToPage", event);
    });
  };

  const erzeugeProduktUrl = (isMakler: boolean, isMaklerLink: boolean, produkt: string) => {
    return isMakler ? (isMaklerLink ? "/makler-tarifrechner/" + produkt : "/makler/" + produkt) : "/" + produkt;
  };

  return {
    pruefeDatenVorhanden,
    erzeugeNavItems,
    nextPage,
    prevPage,
    goToPage,
    getCurrentRouteMeta,
    erzeugeProduktUrl,
  };
}
